"use client";

import React from "react";
import { MapPin, BriefcaseBusiness, CalendarCheck, BadgeDollarSign } from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const details = [{
  label: "Location",
  value: "Thunder Bay, Ontario",
  note: "Primarily based at RiverBend’s office, with some client-community travel possible.",
  icon: MapPin
}, {
  label: "Employment Type",
  value: "Full-Time, Permanent",
  note: "A steady role focused on client financial support, reporting coordination, and follow-through.",
  icon: BriefcaseBusiness
}, {
  label: "Application Status",
  value: "Open Until Filled",
  note: "Applications will be reviewed as they are received.",
  icon: CalendarCheck
}, {
  label: "Compensation",
  value: "$80,000 to $90,000",
  note: "Plus comprehensive benefits and a Defined Contribution Pension Plan.",
  icon: BadgeDollarSign
}];
export default function WhyNevadaChoosesUs() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section data-section-id="257527" id="quick-job-details" className="bg-background py-12 md:py-16 border-y border-border/50">
      <div className="max-w-[1180px] mx-auto px-4 md:px-8">
        <div className="text-center max-w-3xl mx-auto mb-10">
          <p className="text-secondary-500 text-xs font-default font-bold tracking-wider uppercase mb-3">
            Position Overview
          </p>

          <h2 className="text-foreground text-3xl md:text-4xl font-default font-bold mb-4">
            Quick Job Details
          </h2>

          <p className="text-muted-foreground text-base font-default leading-relaxed">
            A practical client-support role focused on financial follow-through,
            reporting coordination, funding documentation, and keeping client
            files moving clearly and consistently.
          </p>
        </div>

        <div ref={ref} className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {details.map((detail, i) => {
          const delayClass = i === 0 ? "delay-0" : i === 1 ? "delay-100" : i === 2 ? "delay-200" : "delay-300";
          return <Card key={i} data-index={i} className={`bg-card border border-border rounded-lg h-full shadow-sm hover:shadow-md transition-all duration-700 ${delayClass} ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-5"}`}>
                <CardContent className="p-6">
                  <div className="flex items-start gap-4">
                    <div className="w-11 h-11 rounded-md bg-secondary-100 flex items-center justify-center text-secondary-600 shrink-0">
                      <detail.icon className="w-5 h-5" />
                    </div>

                    <div>
                      <p className="text-xs uppercase tracking-wider font-default font-bold text-secondary-500 mb-2">
                        {detail.label}
                      </p>

                      <p className="text-primary-500 text-lg font-default font-bold leading-snug mb-2">
                        {detail.value}
                      </p>

                      <p className="text-muted-foreground text-sm font-default leading-relaxed">
                        {detail.note}
                      </p>
                    </div>
                  </div>
                </CardContent>
              </Card>;
        })}
        </div>
      </div>
    </section>;
}